export default {
    heading1: {
        fontSize: '32px',
        lineHeight: '45px',
        fontWeight: 500,
    },
    heading2: {
        fontSize: '30px',
        lineHeight: '42px',
        fontWeight: 400,
    },
    heading3: {
        fontSize: '24px',
        lineHeight: '34px',
        fontWeight: 500,
    },
    heading4: {
        fontSize: '21px',
        lineHeight: '29px',
        fontWeight: 500,
    },
    bodyMedium: {
        fontSize: '15px',
        lineHeight: '21px',
        fontWeight: 500,
    },
    descriptionMedium: {
        fontSize: '14px',
        lineHeight: '20px',
        fontWeight: 500,
    },
    captionMedium: {
        fontSize: '13px',
        lineHeight: '18px',
        fontWeight: 500,
    },
    title1: {
        fontSize: '23px',
        lineHeight: '32px',
        fontWeight: 400,
    },
    title2: {
        fontSize: '22px',
        lineHeight: '31px',
        fontWeight: 400,
    },
    title3: {
        fontSize: '21px',
        lineHeight: '29px',
        fontWeight: 400,
    },
    title4: {
        fontSize: '18px',
        lineHeight: '25px',
        fontWeight: 400,
    },
    body: {
        fontSize: '15px',
        lineHeight: '21px',
        fontWeight: 400,
    },
    description: {
        fontSize: '14px',
        lineHeight: '20px',
        fontWeight: 400,
    },
    caption1: {
        fontSize: '13px',
        lineHeight: '18px',
        fontWeight: 400,
    },
    caption2: {
        fontSize: '12px',
        lineHeight: '17px',
        fontWeight: 400,
    },
    message: {
        fontSize: '11px',
        lineHeight: '15px',
        fontWeight: 400,
    },
    tags: {
        fontSize: '11px',
        lineHeight: '15px',
        fontWeight: 500,
    },
    label: {
        fontSize: '10px',
        lineHeight: '12px',
        fontWeight: 400,
        textTransform: 'uppercase',
    },
    buttonLarge: {
        fontSize: '18px',
        lineHeight: '20px',
        fontWeight: 400,
    },
    buttonMedium: {
        fontSize: '14px',
        lineHeight: '16px',
        fontWeight: 400,
    },
    buttonSmall: {
        fontSize: '12px',
        lineHeight: '14px',
        fontWeight: 400,
    },
    link: {
        fontSize: '14px',
        lineHeight: '16px',
        fontWeight: 400,
        textDecoration: 'underline',
    },
    tableHeader: {
        fontSize: '10px',
        lineHeight: '14px',
        fontWeight: 400,
    },
} as const;
